var map = {
	"./surah.json": [
		13
	],
	"./surah/abasa.json": [
		62,
		3
	],
	"./surah/ad-duha.json": [
		63,
		4
	],
	"./surah/ad-dukhan.json": [
		64,
		5
	],
	"./surah/al-adiyat.json": [
		65,
		6
	],
	"./surah/al-ahqaf.json": [
		66,
		7
	],
	"./surah/al-ahzab.json": [
		67,
		8
	],
	"./surah/al-ala.json": [
		68,
		9
	],
	"./surah/al-alaq.json": [
		69,
		10
	],
	"./surah/al-anam.json": [
		70,
		11
	],
	"./surah/al-anbiya.json": [
		71,
		12
	],
	"./surah/al-anfal.json": [
		72,
		13
	],
	"./surah/al-ankabut.json": [
		73,
		14
	],
	"./surah/al-araf.json": [
		74,
		15
	],
	"./surah/al-asr.json": [
		75,
		16
	],
	"./surah/al-balad.json": [
		76,
		17
	],
	"./surah/al-baqarah.json": [
		77,
		18
	],
	"./surah/al-bayyinah.json": [
		78,
		19
	],
	"./surah/al-buruj.json": [
		79,
		20
	],
	"./surah/al-fajr.json": [
		80,
		21
	],
	"./surah/al-falaq.json": [
		81,
		22
	],
	"./surah/al-fath.json": [
		82,
		23
	],
	"./surah/al-fatihah.json": [
		83,
		24
	],
	"./surah/al-fil.json": [
		84,
		25
	],
	"./surah/al-furqan.json": [
		85,
		26
	],
	"./surah/al-gasyiyah.json": [
		86,
		27
	],
	"./surah/al-hadid.json": [
		87,
		28
	],
	"./surah/al-hajj.json": [
		88,
		29
	],
	"./surah/al-haqqah.json": [
		89,
		30
	],
	"./surah/al-hasyr.json": [
		90,
		31
	],
	"./surah/al-hijr.json": [
		91,
		32
	],
	"./surah/al-hujurat.json": [
		92,
		33
	],
	"./surah/al-humazah.json": [
		93,
		34
	],
	"./surah/al-ikhlas.json": [
		94,
		35
	],
	"./surah/al-infitar.json": [
		95,
		36
	],
	"./surah/al-insan.json": [
		96,
		37
	],
	"./surah/al-insyiqaq.json": [
		97,
		38
	],
	"./surah/al-isra.json": [
		98,
		39
	],
	"./surah/al-jasiyah.json": [
		99,
		40
	],
	"./surah/al-jinn.json": [
		100,
		41
	],
	"./surah/al-jumuah.json": [
		101,
		42
	],
	"./surah/al-kafirun.json": [
		102,
		43
	],
	"./surah/al-kahfi.json": [
		103,
		44
	],
	"./surah/al-kausar.json": [
		104,
		45
	],
	"./surah/al-lahab.json": [
		105,
		46
	],
	"./surah/al-lail.json": [
		106,
		47
	],
	"./surah/al-maarij.json": [
		107,
		48
	],
	"./surah/al-maidah.json": [
		108,
		49
	],
	"./surah/al-maun.json": [
		109,
		50
	],
	"./surah/al-muddassir.json": [
		110,
		51
	],
	"./surah/al-mujadalah.json": [
		111,
		52
	],
	"./surah/al-mulk.json": [
		112,
		53
	],
	"./surah/al-muminun.json": [
		113,
		54
	],
	"./surah/al-mumtahanah.json": [
		114,
		55
	],
	"./surah/al-munafiqun.json": [
		115,
		56
	],
	"./surah/al-mursalat.json": [
		116,
		57
	],
	"./surah/al-mutaffifin.json": [
		117,
		58
	],
	"./surah/al-muzzammil.json": [
		118,
		59
	],
	"./surah/al-qadr.json": [
		119,
		60
	],
	"./surah/al-qalam.json": [
		120,
		61
	],
	"./surah/al-qamar.json": [
		121,
		62
	],
	"./surah/al-qariah.json": [
		122,
		63
	],
	"./surah/al-qasas.json": [
		123,
		64
	],
	"./surah/al-qiyamah.json": [
		124,
		65
	],
	"./surah/al-waqiah.json": [
		125,
		66
	],
	"./surah/ali-imran.json": [
		126,
		67
	],
	"./surah/an-naba.json": [
		127,
		68
	],
	"./surah/an-nahl.json": [
		128,
		69
	],
	"./surah/an-najm.json": [
		129,
		70
	],
	"./surah/an-naml.json": [
		130,
		71
	],
	"./surah/an-nas.json": [
		131,
		72
	],
	"./surah/an-nasr.json": [
		132,
		73
	],
	"./surah/an-naziat.json": [
		133,
		74
	],
	"./surah/an-nisa.json": [
		134,
		75
	],
	"./surah/an-nur.json": [
		135,
		76
	],
	"./surah/ar-rad.json": [
		136,
		77
	],
	"./surah/ar-rahman.json": [
		137,
		78
	],
	"./surah/ar-rum.json": [
		138,
		79
	],
	"./surah/as-saff.json": [
		139,
		80
	],
	"./surah/as-saffat.json": [
		140,
		81
	],
	"./surah/as-sajdah.json": [
		141,
		82
	],
	"./surah/asy-syams.json": [
		142,
		83
	],
	"./surah/asy-syarh.json": [
		143,
		84
	],
	"./surah/asy-syuara.json": [
		144,
		85
	],
	"./surah/asy-syura.json": [
		145,
		86
	],
	"./surah/at-tagabun.json": [
		146,
		87
	],
	"./surah/at-tahrim.json": [
		147,
		88
	],
	"./surah/at-takasur.json": [
		148,
		89
	],
	"./surah/at-takwir.json": [
		149,
		90
	],
	"./surah/at-talaq.json": [
		150,
		91
	],
	"./surah/at-tariq.json": [
		151,
		92
	],
	"./surah/at-taubah.json": [
		152,
		93
	],
	"./surah/at-tin.json": [
		153,
		94
	],
	"./surah/at-tur.json": [
		154,
		95
	],
	"./surah/az-zalzalah.json": [
		155,
		96
	],
	"./surah/az-zariyat.json": [
		156,
		97
	],
	"./surah/az-zukhruf.json": [
		157,
		98
	],
	"./surah/az-zumar.json": [
		158,
		99
	],
	"./surah/fatir.json": [
		159,
		100
	],
	"./surah/fussilat.json": [
		160,
		101
	],
	"./surah/gafir.json": [
		161,
		102
	],
	"./surah/hud.json": [
		162,
		103
	],
	"./surah/ibrahim.json": [
		163,
		104
	],
	"./surah/luqman.json": [
		164,
		105
	],
	"./surah/maryam.json": [
		165,
		106
	],
	"./surah/muhammad.json": [
		166,
		107
	],
	"./surah/nuh.json": [
		167,
		108
	],
	"./surah/qaf.json": [
		168,
		109
	],
	"./surah/quraisy.json": [
		169,
		110
	],
	"./surah/saba.json": [
		170,
		111
	],
	"./surah/sad.json": [
		171,
		112
	],
	"./surah/taha.json": [
		172,
		113
	],
	"./surah/yasin.json": [
		173,
		114
	],
	"./surah/yunus.json": [
		174,
		115
	],
	"./surah/yusuf.json": [
		175,
		116
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 58;
module.exports = webpackAsyncContext;